import { useTranslation } from 'react-i18next';

import { InfoModal } from '../../ui/info-modal/info-modal';

import { useAccount } from 'shared/hooks/use-web3';
import { useUIStore } from 'shared/store/uiStore';

export const RpcErrorModal = () => {
  const { t } = useTranslation();
  const { chainId } = useAccount();
  const { setRpcErrorModalShow } = useUIStore();
  return (
    <InfoModal
      onClose={() => setRpcErrorModalShow(false)}
      title={t('common.attention')}
      className="bg-black bg-opacity-75"
    >
      <p className="relative mb-4 self-stretch text-center text-md font-normal leading-5 text-white/80 md:mb-6 md:text-sm">
        {t('rpcErrorModal.lobby')}
      </p>
      <p className="relative mb-4 self-stretch text-center text-md font-normal leading-5 text-white/80 md:mb-6 md:text-sm">
        {t('rpcErrorModal.discord')}
      </p>
      <a
        target="_blank"
        rel="noreferrer"
        href={`https://chainlist.org/chain/${chainId}`}
        className="relative cursor-pointer self-stretch text-center text-base font-normal leading-6 text-light-grape underline md:text-xl"
      >
        {t('rpcErrorModal.check')}
      </a>
    </InfoModal>
  );
};
